export class AdminPageDefinition {
    constructor(public title = "", public category = "", public icon = "", public routerLink: string[] = []) {
    }
}